export default __webpack_public_path__ + "static/media/cemento-consejo.0ad6b274.jpg";